import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ModernSelect as Select } from 'shared/ui/ModernSelect';
import { NotesListFilterKeys } from '../../model/types';
import { NoteType } from 'entities/Note';

interface NoteTypeSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const NoteTypeSelect: FC<NoteTypeSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('contracts');

  const noteTypeOptions = useMemo<Array<{ label: string; value: NoteType }>>(() => {
    return Object.values(NoteType).map((type) => ({
      label: t(type),
      value: type,
    }));
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(NotesListFilterKeys.noteType);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Note type')}
      placeholder={t('All')}
      bordered
      allowClear
      options={noteTypeOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
